<template>
  <div class="w-11/12 lg:w-7/12 mx-auto mt-5">
    <div v-if="isTimeout" class="lg:w-10/12 mx-auto">
      <div class="flex flex-col items-center justify-center">
        <system-error />
        <h3 class="text-fg-default text-xl mt-4 mb-2">Deposit Time Out</h3>
        <p
          style="word-break: normal"
          class="text-xs lg:text-sm text-fg-muted font-light text-center"
        >
          We were unable to receive your deposit through the countdown please
          try again or click on dispute if you think this is an error
        </p>
      </div>
      <div class="flex flex-row items-center gap-x-2 mt-10 mb-5">
        <a
          href="https://ovalfi.atlassian.net/servicedesk/customer/portals"
          target="_blank"
          class="w-full border border-primary text-primary text-sm rounded-lg py-3.5 text-center"
          @click="dispute"
          >Dispute</a
        >
        <el-button
          class="bg-primary rounded-lg text-white text-sm shadow-sm py-3.5 w-full"
          @click="retryHandler"
          >Try Again</el-button
        >
      </div>
    </div>
    <!-- amount changed -->
    <div v-if="isAmountMismatch">
      <div class="flex flex-col items-center justify-center">
        <warning-icon-2 />
        <h3 class="text-fg-default text-xl mt-4 mb-2 font-semibold">
          Amount Change
        </h3>
        <ul class="font-normal w-4/5 my-4 text-xs lg:text-sm">
          <li class="flex items-center justify-between mb-3 text-fg-muted">
            <span>Transfer Amount</span>
            <span class="font-bold">{{
              parseMoneyAll(transferDetails.debitAmount, country.currency)
            }}</span>
          </li>
          <li class="flex items-center justify-between text-root-2">
            <span>We Received</span>
            <span>{{
              parseMoneyAll(depositedAmountReceived, country.currency)
            }}</span>
          </li>
        </ul>
        <p
          style="word-break: normal"
          class="font-normal w-full text-center px-3 py-5 border border-dashed rounded-2xl text-fg-muted text-xs lg:text-sm"
        >
          We received
          <span class="font-bold text-root-2">{{
            parseMoneyAll(depositedAmountReceived, country.currency)
          }}</span>
          instead of
          <span class="font-bold text-root-2">{{
            parseMoneyAll(transferDetails.debitAmount, country.currency)
          }}</span>
          you initially specified. You would have to <br />update the
          transaction before you can <br />proceed.
        </p>
      </div>
      <div
        v-if="!isExternalApi"
        class="flex flex-row items-center gap-x-4 mt-7 mb-10 px-4"
      >
        <o-button class="w-full" @click="updateTransaction"
          >Update Transaction</o-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { ParseMoneyAll } from '@/utils/helpers'
import country from '@/mixins/getCountryDetails.js'
import localDeposit from '@/mixins/localDeposit.js'
export default {
  mixins: [country, localDeposit],
  props: {
    use: {
      type: String,
      default: ''
    }
  },
  components: {
    SystemError: () => import('@/assets/icons/SystemError.vue'),
    WarningIcon2: () => import('@/assets/icons/WarningIcon2.vue')
  },
  computed: {
    transferDetails () {
      return (
        this.$store.state.terminal.transferTerminalDetails.transferDetails || {}
      )
    },
    isTimeout () {
      return this.$store.state.terminal.failedDepositAssetReason === 'timeout'
    },
    isAmountMismatch () {
      return (
        this.$store.state.terminal.failedDepositAssetReason ===
        'amount-mismatch'
      )
    },
    pendingAssetDeposits () {
      return this.$store.state.transactions.deposits.items
    },
    depositedAmountReceived () {
      const depositDetails = this.pendingAssetDeposits.find(
        (deposit) => deposit.amount.currency === this.country.currency
      )
      return depositDetails.amount.amount
    },
    isExternalApi () {
      return this.use === 'externalApi'
    }
  },
  methods: {
    retryHandler () {
      this.$emit('setView', 'confirm-deposit')
    },
    updateTransaction () {
      const details = {
        debitAmount: this.depositedAmountReceived
      }
      this.$store.dispatch('terminal/setTransferDetails', details)
      this.$store.dispatch('terminal/hasBeenDebited', true)
      this.$emit('updateAssetTransferDetails')
    },
    parseMoneyAll (amount, currency) {
      return ParseMoneyAll(amount, currency)
    },
    dispute () {
      this.$emit('dispute')
    }
  }
}
</script>
